import { Grid } from "@material-ui/core"
import FCompras from "../FCompras"
import TCompras from "./TCompras"
const VCompras = () => {
    return (
        <div>
                <Grid container>
                    <Grid item xs={4}>
                        <FCompras />
                    </Grid>
                    <Grid item xs={8}>
                        <TCompras />
                    </Grid>
                </Grid>
        </div>
    )
}
export default VCompras